import React from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import SLMEntityLinkList from "containers/slm/shared/SLMEntityLinkList";

export default function SLMAgentAgencyPanel({
  state,
  disabled = false,
  onChange,
  onBlur,
  isAuthenticated,
  updateTableState,
  saveRecord,
  deleteRecord,
  sale_id = null,
  lease_id = null,
  user,
  state_code,
  validateRelatedRecord,
  getAgencies,
  getAgents,
  getEntityLinks,
  updateAgencyFields,
}) {
  const readOnly = disabled || state.entityLinks.length > 0;

  return (
    <Card className="mb-2">
      <Card.Header>Agents & Agencies</Card.Header>
      <Card.Body>
        <Form.Group as={Row} controlId="agent">
          <Form.Label className="text-right" column sm={4} md={4} lg={2}>
            Agent
          </Form.Label>
          <Col>
            <Form.Control disabled={disabled} readOnly={readOnly} onChange={onChange} onBlur={onBlur} value={state.agent ?? ""} as="input" type="text" style={{ backgroundColor: readOnly ? "#e9ecef" : "#fff" }} />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="agency">
          <Form.Label className="text-right" column sm={4} md={4} lg={2}>
            Agency
          </Form.Label>
          <Col>
            <Form.Control disabled={disabled} readOnly={readOnly} onChange={onChange} onBlur={onBlur} value={state.agency ?? ""} as="input" type="text" style={{ backgroundColor: readOnly ? "#e9ecef" : "#fff" }} />
          </Col>
        </Form.Group>

        <Row>
          <Col>
            <SLMEntityLinkList
              isAuthenticated={isAuthenticated}
              controlType="table2"
              data={state.entityLinks}
              updateTableState={updateTableState}
              saveRecord={saveRecord}
              deleteRecord={deleteRecord}
              sale_id={sale_id}
              lease_id={lease_id}
              user={user}
              state_code={state_code}
              validateRelatedRecord={validateRelatedRecord}
              getAgencies={getAgencies}
              getAgents={getAgents}
              getEntityLinks={getEntityLinks}
              updateAgencyFields={updateAgencyFields}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
